export default function isWeiXin() {
  if(navigator.userAgent.toLowerCase().indexOf('micromessenger') > -1 ||
      typeof navigator.wxuserAgent !== 'undefined') {
    return true;
  } else {
    return false;
  }
}